import { render } from "./indexedColors.vue?vue&type=template&id=601e0f34&ts=true"
import script from "./indexedColors.vue?vue&type=script&lang=ts"
export * from "./indexedColors.vue?vue&type=script&lang=ts"

import "./indexedColors.vue?vue&type=style&index=0&id=601e0f34&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__